import React from 'react'

// third party and libaries
import { Card, Table } from "react-bootstrap"

// components
import AnimationLoading from '../../../components/Animationloading';
import { covertTimeZone, HandleCurrency, numberFormat } from '../../../helper';
import _ from 'lodash';

export default function OrderStaffLists(props) {

    const { initailDatas, distinguish } = props;
    let _limit = initailDatas?._limit;
    let _skip = initailDatas?._skip;
    // if is empty to loading
    if (initailDatas?.loadingOrderReport && !initailDatas?.orderAndReportStaff) return <AnimationLoading />
    if(_.isEmpty(initailDatas?.orderGroups)) return <div style={{width:'100%', height:'60vh',display:'flex', justifyContent:'center', alignItems:'center'}}>
        <img style={{width:'30%'}} src="https://static.vecteezy.com/system/resources/previews/017/979/676/non_2x/file-text-education-pencil-blue-icon-on-abstract-cloud-background-free-vector.jpg" />
    </div>

    return (
        <Card border='light' style={{ padding: 0 }}>
            <Table responsive>
                <thead>
                    <tr>
                        {distinguish ? (
                            <>
                            <th>#</th>
                            <th style={{minWidth: 100}}>ເລກທີບິນ</th>
                            <th style={{minWidth: 100}}>ຊື່ລູກຄ້າ</th>
                            <th style={{minWidth: 100}}>ນາມສະກຸນ</th>
                            <th style={{minWidth: 200}}>ບ້ານ, ເມືອງ, ແຂວງ</th>
                            <th style={{minWidth: 100}}>ເບີໂທລູກຄ້າ</th>
                            <th style={{minWidth: 100}}>ສີນຄ້າ</th>
                            <th style={{minWidth: 50}}>ຈຳນວນ</th>
                            <th style={{minWidth: 200}}>ຍອດເງິນ</th>
                            <th style={{minWidth: 200}}>ວັນທີ,ເດືອນ,ປີ</th>
                            </>
                        ) : (
                            <>
                            <th>#</th>
                            <th style={{minWidth: 100}}>ເລກທີບິນ</th>
                            <th style={{minWidth: 100}}>ຊື່ລູກຄ້າ</th>
                            <th style={{minWidth: 100}}>ນາມສະກຸນ</th>
                            <th style={{minWidth: 200}}>ບ້ານ, ເມືອງ, ແຂວງ</th>
                            <th style={{minWidth: 100}}>ເບີໂທລູກຄ້າ</th>
                            <th style={{minWidth: 50}}>ຈຳນວນ</th>
                            <th style={{minWidth: 200}}>ຍອດເງິນ</th>
                            <th style={{minWidth: 200}}>ວັນທີ,ເດືອນ,ປີ</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {initailDatas?.orderGroups.map((item, index) => (
                        <tr key={index}>
                            {distinguish ? (
                                <>
                                    <td style={{backgroundColor: item.status === "COMPLETED" ? "green" : "red"}}>
                                        {index + 1 + _limit * (_skip - 1)}
                                    </td>
                                    <td>{item?.code ?? "-"}</td>
                                    <td>{item?.customerName ?? "-"}</td>
                                    <td>{item?.customerLastName ?? "-"}</td>
                                    <td>{item?.village ?? "-"} { item?.district ?? "-"} {item?.province ?? "-"}</td>
                                    <td>{item?.phone ?? "-"}</td>
                                    <td>{item?.orders?.stock?.name ||  "-"}</td>
                                    <td>{item?.orders?.amount ?? 0 }</td>
                                    <td>
                                    {numberFormat(item?.orders?.totalPrice?? 0) + " " + HandleCurrency(item?.orders?.currency)}
                                    </td>
                                    <td>{covertTimeZone(item?.createdAt, ' HH:ss a')}</td>
                                </>
                            ) : (
                                <>
                                    <td style={{backgroundColor: item.status === "COMPLETED" ? "green" : "red"}}>
                                        {index + 1 + _limit * (_skip - 1)}
                                    </td>
                                    <td>{item?.code ?? "-"}</td>
                                    <td>{item?.customerName ?? "-"}</td>
                                    <td>{item?.customerLastName ?? "-"}</td>
                                    <td>{item?.village ?? "-"} { item?.district ?? "-"} {item?.province ?? "-"}</td>
                                    <td>{item?.phone ?? "-"}</td>
                                    <td>{item?.amount ?? 0 }</td>
                                    <td>
                                    {numberFormat(item?.sumPrice ?? 0) + " " + HandleCurrency(item?.currency)}
                                    </td>
                                    <td>{covertTimeZone(item?.createdAt, ' HH:ss a')}</td>
                                </>
                            )}
                        </tr>
                    ))}

                </tbody>
            </Table>

        </Card>
    )
}
